export const APOLLO_SERVICE_NAMES = {
  CATALOG: "catalog",
  VMS: "vms",
  DISTRIBUTOR: "distributor",
};

export const API_ROUTES = {
  SEND_MAGIC_LINK: "/iam/auth/send-magic-link",
  VERIFY_MAGIC_LINK: "iam/auth/login",
  GET_USER_INFO: "/iam/user/authenticate",
  UPLOAD_IMAGE_TO_S3: "/upload/image",
  CALCULATE_PRICE_WITH_MARKUP: "catalog/calculate-price-with-markup",
}